import { useState } from "react";
import { useAuthStore } from "@/store/authStore";
import api from "@/api/client";

export default function SolidGroundLogin() {
  const set = useAuthStore.setState;

  const [masterKey, setMasterKey] = useState("");
  const [password,  setPassword]  = useState("");
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState("");
  const [showPass,  setShowPass]  = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError("");
    if (!masterKey.trim() || !password.trim()) { setError("Bitte alle Felder ausfüllen"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/solid-ground-access", {
        masterKey: masterKey.trim(),
        password:  password.trim(),
      });
      set({ token: data.token, user: data.user, isAuthenticated: true });
    } catch (err) {
      setError(err.response?.data?.error || "Zugang verweigert");
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100dvh", background: "#030310",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "0 16px", position: "relative", overflow: "hidden",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>
      {/* Animated gold atmosphere */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "1px", background: "linear-gradient(90deg, transparent, rgba(251,191,36,0.6), rgba(245,158,11,0.6), transparent)" }} />
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: "1px", background: "linear-gradient(90deg, transparent, rgba(251,191,36,0.3), transparent)" }} />
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse at 50% 0%, rgba(251,191,36,0.07), transparent 60%)" }} />
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse at 50% 100%, rgba(245,158,11,0.05), transparent 50%)" }} />
      </div>

      <form onSubmit={handleSubmit} style={{ position: "relative", zIndex: 10, width: "100%", maxWidth: 320 }}>
        {/* Logo + label */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 32 }}>
          {/* Gold shield badge */}
          <div style={{ marginBottom: 12, filter: "drop-shadow(0 0 20px rgba(251,191,36,0.7))" }}>
            <svg width="52" height="52" viewBox="0 0 24 24" fill="#fbbf24">
              <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
            </svg>
          </div>
          <p style={{ fontSize: 18, fontWeight: 900, color: "#fbbf24", letterSpacing: "0.04em", marginBottom: 4 }}>
            SOLID GROUND
          </p>
          <p style={{ fontSize: 10, color: "rgba(251,191,36,0.5)", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase" }}>
            Platform Owner Access
          </p>
        </div>

        <div style={{
          background: "rgba(251,191,36,0.04)", border: "1px solid rgba(251,191,36,0.2)",
          borderRadius: 20, padding: 24, display: "flex", flexDirection: "column", gap: 16,
          boxShadow: "0 0 40px rgba(251,191,36,0.06)",
        }}>
          {/* Master Key */}
          <div>
            <label style={{ display: "block", fontSize: 10, color: "rgba(251,191,36,0.5)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6 }}>
              Master Key
            </label>
            <input
              type="text"
              value={masterKey}
              onChange={(e) => setMasterKey(e.target.value)}
              placeholder="Schlüssel eingeben"
              autoComplete="off"
              style={{
                width: "100%", boxSizing: "border-box",
                background: "rgba(251,191,36,0.05)", border: "1px solid rgba(251,191,36,0.15)",
                borderRadius: 12, padding: "10px 14px",
                fontSize: 13, color: "#fff", fontFamily: "monospace",
                outline: "none",
              }}
              onFocus={(e) => { e.target.style.borderColor = "rgba(251,191,36,0.5)"; }}
              onBlur={(e)  => { e.target.style.borderColor = "rgba(251,191,36,0.15)"; }}
            />
          </div>

          {/* Password */}
          <div>
            <label style={{ display: "block", fontSize: 10, color: "rgba(251,191,36,0.5)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6 }}>
              Passwort
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPass ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort eingeben"
                autoComplete="current-password"
                style={{
                  width: "100%", boxSizing: "border-box",
                  background: "rgba(251,191,36,0.05)", border: "1px solid rgba(251,191,36,0.15)",
                  borderRadius: 12, padding: "10px 40px 10px 14px",
                  fontSize: 13, color: "#fff", fontFamily: "monospace",
                  outline: "none",
                }}
                onFocus={(e) => { e.target.style.borderColor = "rgba(251,191,36,0.5)"; }}
                onBlur={(e)  => { e.target.style.borderColor = "rgba(251,191,36,0.15)"; }}
              />
              <button
                type="button"
                onClick={() => setShowPass(v => !v)}
                style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "rgba(251,191,36,0.4)", padding: 0 }}
              >
                {showPass
                  ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                  : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                }
              </button>
            </div>
          </div>

          {error && (
            <div style={{
              display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
              background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)",
              borderRadius: 10, fontSize: 12, color: "#fca5a5",
            }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "12px",
              borderRadius: 12,
              background: loading ? "rgba(251,191,36,0.15)" : "linear-gradient(135deg, rgba(251,191,36,0.25), rgba(245,158,11,0.2))",
              border: "1px solid rgba(251,191,36,0.4)",
              color: loading ? "rgba(251,191,36,0.5)" : "#fbbf24",
              fontSize: 13, fontWeight: 900, cursor: loading ? "not-allowed" : "pointer",
              letterSpacing: "0.05em",
              boxShadow: loading ? "none" : "0 0 20px rgba(251,191,36,0.15)",
              transition: "all 0.2s ease",
              fontFamily: "inherit",
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.boxShadow = "0 0 30px rgba(251,191,36,0.3)"; }}
            onMouseLeave={(e) => { if (!loading) e.target.style.boxShadow = "0 0 20px rgba(251,191,36,0.15)"; }}
          >
            {loading ? "Authentifizierung…" : "Solid Ground Zugang"}
          </button>
        </div>
      </form>
    </div>
  );
}
